import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import request from 'superagent';

var makeApiRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var url, methodType, body, responseType, headers, payload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = config.url, methodType = config.methodType, body = config.body, responseType = config.responseType, headers = config.headers;
            _context.prev = 1;
            _context.next = 4;
            return request(methodType, url).set(_objectSpread({}, headers)).withCredentials().responseType(responseType || 'json').send(body || null);

          case 4:
            payload = _context.sent;
            return _context.abrupt("return", {
              data: payload.body
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            throw new Error('An error has occured with the wishlist service');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function makeApiRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default makeApiRequest;